export default {
  verification:{
    title:'メールアドレスを入力してください',
    phone:'携帯電話',
    email:'メールアドレス',
    btn:'検証コード送信',
    modalTitle:'検証コードを入力してください',
    modalBtn:'確認',
     emailplaceholder:'メールアドレスを入力してください',
    bnnameplaceholder:'推薦者または BD の名前(任意入力)',
    bnnameplaceholder2:'推薦者または BD の名前',
  }
}
